function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M352 265.768H160c0 13.255 11.544 23.999 24.799 23.999H184c0 13.255 10.744 24.001 24.001 24.001 0 13.255 10.744 24.001 24.001 24.001h48c13.255 0 24.001-10.744 24.001-24.001 13.255 0 24.001-10.744 24.001-24.001h-.799c13.249 0 24.795-10.744 24.795-23.999z",
  fill: "#ffda44"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M322.462 234.384c0 36.705-29.756 66.462-66.462 66.462s-66.462-29.756-66.462-66.462",
  fill: "#338af3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M321.882 228.163l-26.92 10.899 14.335 22.441-29.232-4.814-3.704 25.415L256 263.412l-20.362 18.692-3.703-25.415-29.232 4.812 14.334-22.44-26.919-10.898 26.92-10.899-14.335-22.439 29.231 4.813 3.705-25.417L256 192.915l20.362-18.694 3.703 25.417 29.233-4.813-14.335 22.44z"
});

const SvgKazakhstan = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKazakhstan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kazakhstan.d5b20160.svg";
export { ForwardRef as ReactComponent };